export default __webpack_public_path__ + "static/media/2021-05-01-hello-world.fe6b8fa3.md";